export default {
  defaultComparisons: [
    {
      title: 'Custom',
      selected: true, // default comparison in 'filters' mode (SurveyResults)
      filters: {
        derivedVarNames: [],
        questionIds: [],
        variableIds: [],
        membershipType: false,
      },
      filterValues: {
        derivedVarValues: {},
        variableValues: {},
        membershipTypeIds: [],
      },
      charts: {
        derivedVarNames: [],
        questionIds: [],
        variableIds: [],
      },
    },
  ],
  defaultResultCharts: {
    title: 'Custom',
    selected: false,
    filters: {
      derivedVarNames: [],
      questionIds: [],
      variableIds: [],
      membershipType: false,
    },
    filterValues: {
      derivedVarValues: {},
      variableValues: {},
      membershipTypeIds: [],
    },
    charts: {
      derivedVarNames: [],
      questionIds: [],
      variableIds: [],
    },
  },
};
